"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constType = void 0;
const caster_cache_1 = require("./caster-cache");
function constType(declaration, validateOptions, circularCache = caster_cache_1.createCache()) {
    if (declaration === null || typeof declaration !== 'object') {
        throw new Error('First argument (declaration) must be an Object.');
    }
    const circularCaster = circularCache.get(declaration);
    if (circularCaster !== undefined) {
        return circularCaster;
    }
    const { type, required, const: constValue } = declaration;
    if (type !== 'Const') {
        throw new Error('"type" property on declaration must be "Const"');
    }
    if (required !== undefined && typeof required !== 'boolean') {
        throw new Error('"required" property on declaration must be undefined or a Boolean');
    }
    if (constValue === undefined ||
        (typeof constValue !== 'boolean' &&
            constValue instanceof Date !== true &&
            typeof constValue !== 'number' &&
            typeof constValue !== 'string')) {
        throw new Error('"const" property on declaration must be a Boolean, Date, Number or String');
    }
    const caster = (candidate) => {
        if (candidate === undefined || candidate === null) {
            if (required === false) {
                return {
                    type,
                    isValid: true,
                    invalidations: [],
                    candidate: constValue
                };
            }
            else {
                return {
                    type,
                    isValid: false,
                    candidate,
                    invalidations: [[[], 'Const', 'required', true, candidate]]
                };
            }
        }
        if (constValue instanceof Date) {
            if (candidate instanceof Date === false || candidate.getTime() !== constValue.getTime()) {
                return {
                    type,
                    isValid: false,
                    candidate,
                    invalidations: [[[], 'Const', 'const', constValue, candidate]]
                };
            }
        }
        else {
            if (constValue !== candidate) {
                return {
                    type,
                    isValid: false,
                    candidate,
                    invalidations: [[[], 'Const', 'const', constValue, candidate]]
                };
            }
        }
        return {
            type,
            invalidations: [],
            isValid: true,
            candidate
        };
    };
    return circularCache.set(declaration, caster);
}
exports.constType = constType;
